import lazyLoading from "../lazyLoading";
export default [
  {
    path: "personal-center",
    meta: {
      title: "个人信息",
      icon: "contacts",
      activeIcon: "contacts",
      showPage: true,

    },
    component: lazyLoading("views/page/personal-center/personal-center"),
    children: [],
  },
  {
    path: "advanced",
    meta: {
      title: "先进管理",
      icon: "setting",
      activeIcon: "setting",
      showPage: true,
      keepAlive: true
    },
    component: lazyLoading("views/page/advanced/advanced"),
    children: [],
  },
  // {
  //   path: "look-advanced",
  //   meta: {
  //     title: "先进管理查看",
  //     icon: "setting",
  //     activeIcon: "setting",
  //     showPage: false,
  //   },
  //   component: lazyLoading("views/page/personal-center/personal-center"),
  //   children: [],
  // },
  {
    path: "look-advanced",
    meta: {
      title: "先进管理查看",
      icon: "setting",
      activeIcon: "setting",
      showPage: false,
      keepAlive: true
    },
    component: lazyLoading("views/page/personal-center/personal-center"),
    children: [],
  },
  {
    path: "analysis",
    meta: {
      title: "数据分析",
      icon: "bar-chart",
      activeIcon: "bar-chart",
      showPage: true,
    },
    component: lazyLoading("views/page/analysis/analysis"),
    children: [],
  },
  {
    path: "account",
    meta: {
      title: "账号管理",
      icon: "team",
      activeIcon: "team",
      showPage: true,
    },
    component: lazyLoading("views/page/account/account"),
    children: [],
  },
  {
    path: "version",
    meta: {
      title: "账号修改",
      icon: "schedule",
      activeIcon: "schedule",
      showPage: true,
    },
    component: lazyLoading("views/page/modification/modification"),
    children: [],
  },
  // {
  //   path: "module-management",
  //   meta: {
  //     title: "模块管理",
  //     icon: "schedule",
  //     activeIcon: "schedule",
  //     showPage: true,
  //   },
  //   component: lazyLoading("views/page/module-management/module-management"),
  //   children: [],
  // },
  // {
  //   path: "audit-message",
  //   meta: {
  //     title: "留言审核",
  //     icon: "schedule",
  //     activeIcon: "schedule",
  //     showPage: true,
  //   },
  //   component: lazyLoading("views/page/audit-message/audit-message"),
  //   children: [],
  // }
  
];
